import { z } from 'zod';

/**
 * What `apps/api` answers on `/security/unidentified-refusals`, parsed rather
 * than cast.
 *
 * Objects strip unknown keys (zod's default), so a field the contract does not
 * define, such as an email or a token, never reaches a component even if a
 * future server sent one. The BFF already drops them; this is the second wall.
 *
 * `reason` is a string, not an enum: a reason a newer server adds is shown with
 * its raw value instead of failing the whole page (see `reasonLabel`).
 */
export const RefusalRecord = z.object({
    id: z.string(),
    occurredAt: z.string(),
    action: z.string(),
    reason: z.string(),
    provider: z.string().optional(),
    domain: z.string().optional(),
    ipAddress: z.string().optional(),
    traceId: z.string().optional(),
});
export type RefusalRecord = z.infer<typeof RefusalRecord>;

export const RefusalPage = z.object({
    records: z.array(RefusalRecord),
    nextCursor: z.string().optional(),
});
export type RefusalPage = z.infer<typeof RefusalPage>;

export const RefusalSummary = z.object({
    byReason: z.array(z.object({ reason: z.string(), count: z.number() })),
    byHour: z.array(z.object({ hourStart: z.string(), count: z.number() })),
});
export type RefusalSummary = z.infer<typeof RefusalSummary>;
